import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/vehicle-feature-item.dto';

export * from './enums/vehicle-feature-item-type.enum';

export * from './types/vehicle-feature-items-filters';

export * from './validators/schemas/vehicle-feature-item.schema';

export const vehicleFeatureItemValidators = { canCreateOrUpdate };
